import React from "react";
import Buttons from "../../atoms/Buttons";
import { Icons } from "../../atoms/Icons";
import { isHybridMember } from "../../helpers/helpers";
import { hideDBonline } from "../../constants/constants";

const HybridMemberLink = ({ membershipType, btnName }) => {
  if (!isHybridMember(membershipType)) return null;

  const handleClick = () => {
    const token = JSON.parse(localStorage.getItem("user")).id_token;
    {
      /* TODO - remove hideDBonline when TPT asks */
    }
    const url = hideDBonline
      ? "https://bbc.co.uk"
      : `https://memberonline.tpt.org.uk/Member?token=${encodeURIComponent(
          token,
        )}`;
    window.open(url);
  };

  return (
    <>
      <Buttons
        name={btnName}
        className="tertiary me-2"
        handleClick={handleClick}
      />
      <Icons iconname="external-link" variant="icon-thirteen-px" />
    </>
  );
};

export default HybridMemberLink;
